import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ApiCaller } from "../../config/api/api";
import PartyPackages from "../party packages/partyPackages";
import BarMenu from "../barAndfood/barmenu";
import Data from "../../assets/data/data";

const Menu = () => {
  const [menuData, setMenuData] = useState(null);
  const [todaySpecialMenu, setTodaySpecialMenu] = useState(null);
  const [activeType, setActiveType] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);

  const { title } = useParams();

  const filteredEvents = Data.find((val) => val.live_Events);

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const data = await ApiCaller("menu-items/", "GET");
        setMenuData(data);
        if (data?.results && data.results.length > 0) {
          const uniqueTypes = [
            ...new Set(data.results.map((item) => item.type_display)),
          ];
          setActiveType(uniqueTypes[0]);

          const firstTypeItems = data.results.filter(
            (item) => item.type_display === uniqueTypes[0]
          );
          setFilteredItems(firstTypeItems);
        }
      } catch (error) {
        console.error('"Error at gallery Api', error.message);
      }
    };
    fetchMenuItems();
  }, []);

  useEffect(() => {
    const fetchTodaySpecial = async () => {
      try {
        const data=await ApiCaller('today-special/','GET')
        setTodaySpecialMenu(data);
      } catch (error) {
       console.error("error in todays special api",error);
      }
    };
    fetchTodaySpecial();
  }, []);

  const handleTypeClick = (type) => {
    setActiveType(type);
    const typeItems = menuData.results.filter(
      (item) => item.type_display === type
    );
    setFilteredItems(typeItems);
  };

  const renderSection = () => {
    switch (title) {
      case "foods":
        return (
          <div id="foods">
            <div className="flex flex-wrap gap-2 mb-6">
              <BarMenu />
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {filteredItems.map((item, index) => (
                <div
                  key={index}
                  className="bg-white p-4 rounded-lg text-white flex gap-3"
                >
                  <div>
                    <img
                      src={item.image_url}
                      alt="image_url"
                      className="w-20 h-20 object-cover"
                    />
                  </div>
                  <div>
                    <div className="text-red-500 font-bold text-sm">
                      {item.title}
                    </div>
                    <div className="font-bold text-black text-sm my-2">
                      Rs.{item.price}/-
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      case "live-music":
        return (
          <div id="live-music" className="text-white p-6">
            <div className="text-2xl font-bold mb-4">Live Music</div>
            <div className="flex gap-3">
              {filteredEvents &&
                filteredEvents.live_Events &&
                filteredEvents.live_Events.map((val, id) => (
                  <div key={id}>
                    <div>
                      <img
                        src={val.artist}
                        alt="val.artist_1"
                        className="w-full"
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        );
      case "todays-special":
        return (
          <div id="todays-special" className="text-white p-6">
            <h2 className="text-2xl font-bold mb-4">Today's Special</h2>
            {todaySpecialMenu ? (
              <div>
                {todaySpecialMenu.map((category, categoryIndex) => (
                  <div key={categoryIndex} className="mb-8">
                    <div className="text-xl font-semibold text-red-500 mb-4 capitalize">
                      {category.category}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {category.items.map((item, itemIndex) => (
                        <div
                          key={itemIndex}
                          className="bg-white p-4 rounded-lg text-white flex gap-3"
                        >
                          <div>
                            <img
                              src={item.image_url}
                              alt={item.name}
                              className="w-20 h-20 object-cover rounded"
                            />
                          </div>
                          <div>
                            <div className="text-red-500 font-bold text-sm">
                              {item.name}
                            </div>
                            <div className="text-gray-600 text-xs my-1">
                              {item.description}
                            </div>
                            <div className="font-bold text-black text-sm">
                              Rs.{item.price}/-
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="w-full h-[8em] bg-gray-700 rounded-md animate-pulse"></div>
            )}
          </div>
        );
      case "party-packages":
        return (
          <div id="party-packages" className="text-white p-6">
            <PartyPackages />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <section className="py-14 px-5 sm:px-14 md:px-16 lg:px-20 bg-black">
      {renderSection()}
    </section>
  );
};

export default Menu;
